import { Button, ButtonProps } from "../ui/button";

interface GrayRoundButtonProps extends ButtonProps {
    image: string;
}

const GrayRoundButton = ({ image, ...props }: GrayRoundButtonProps) => (
    <Button
        className="bg-icon-dark shadow-lg hover:bg-icon-base"
        size="icon"
        variant="ghost"
        {...props}
    >
        <img
            alt="Assistant Logo"
            className="text-icon-active h-5 w-5"
            src={image}
        />
    </Button>
);

export default GrayRoundButton;
